import { ReactComponent as Icon } from "../images/initial-payment-icon.svg";

const InitialPaymentIcon  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default InitialPaymentIcon;
